import React from 'react'
import FindingFieldWrap from './formField/FindingFieldWrap'

export default function FindingFieldRenderer(props) {

  return (
    <>
      <FindingFieldWrap {...props} />
    </>
  )
}